import { SortOrder } from 'kentico-cloud-delivery';
import { KENTICO_TYPES } from 'common/consts/kentico';
import Client from './kenticoClient';
import LanguageService from './Language.service';

class BlogService {
  client = Client;

  async fetchArticlesDetails() {
    const query = this.client.items()
      .type(KENTICO_TYPES.BLOG_ARTICLE)
      .equalsFilter('system.language', LanguageService.getLanguage())
      .elementsParameter([
        'listing___image',
        'title',
        'slug',
        'related_products',
        'article_author',
        'name',
        'description',
        'image',
        'position',
        'categories__blog_category',
        'main_category__blog_category',
      ])
      .orderParameter('elements.publication_date', SortOrder.desc);

    return query.getPromise();
  }

  async fetchLatestArticle(fallback) {
    const query = this.client.items()
      .type(KENTICO_TYPES.BLOG_ARTICLE)
      .equalsFilter('system.language', LanguageService.getLanguage())
      .depthParameter(10)
      .limitParameter(1)
      .orderParameter('elements.publication_date', SortOrder.desc);

    if (!fallback) {
      query.equalsFilter('elements.promoted__promoted[any]', 'yes');
    }

    return query.getPromise();
  }

  async getArticleBySlug(slug) {
    const query = this.client.items()
      .type(KENTICO_TYPES.BLOG_ARTICLE)
      .depthParameter(10)
      .equalsFilter('elements.slug', slug);

    return query.getPromise();
  }
}

export default new BlogService();



// WEBPACK FOOTER //
// ./src/services/Blog.service.js